import type { Dayjs } from 'dayjs';

export type DurationRange = [number, number];

/** The filters the record tables (Pending, Records) share, as applied to the rows. */
export interface RecordFilters {
    search: string;
    status: string;
    deviceType: string;
    durationRange: DurationRange;
    labels: string[];
}

export interface DateRange {
    start: Dayjs;
    // null = "up to now", resolved when the request is sent. A refetch (e.g. after
    // a mutation) then reaches past the moment the page was opened without the
    // range, and so the query key, having to change.
    end: Dayjs | null;
}

export const DEFAULT_DURATION_RANGE: DurationRange = [0, Number.POSITIVE_INFINITY];

export const INITIAL_FILTERS: RecordFilters = {
    search: '',
    status: 'any',
    deviceType: 'all',
    durationRange: DEFAULT_DURATION_RANGE,
    labels: [],
};
